export const ShortAPI = {
  random: openapiStrictFetch({
    url: 'v2/shorts/random',
    options: {
      selfInterrupted: true,
      methodKey: 'shorts_random',
    },
  }),

  categories: openapiStrictFetch({
    url: 'v2/shorts/categories',
  }),
};
